export enum Permission {
  // General Catalog Admin Permissions
  CatalogAdminViewAccess = 'catalog_admin.view',
  CatalogAdminModifyAccess = 'catalog_admin.modify',

  // General Detection Admin Permissions
  CatalogDetectionViewAccess = 'catalog_detection.view',
  CatalogDetectionModifyAccess = 'catalog_detection.modify',

  // Detection Manager Permissions
  CatalogDetectionManagementModifyAccess = 'catalog_detection_management.modify',

  // Attribute Management Platform (CAMP) Permissions — these are what the GraphQL Mesh
  // enforces for WavesService resolvers (catalog_attribute_management_platform.*).
  AttributeManagementPlatformViewAccess = 'catalog_attribute_management_platform.view',
  AttributeManagementPlatformModifyAccess = 'catalog_attribute_management_platform.modify',

  // QAS Permissions
  QualityAuditViewAccess = 'catalog_admin_quality_audit.view',
  QualityAuditModifyAccess = 'catalog_admin_quality_audit.modify',

  // QAS Manager Permissions
  QualityAuditManagerViewAccess = 'catalog_admin_quality_audit_management.view',
  QualityAuditManagerModifyAccess = 'catalog_admin_quality_audit_management.modify',

  // QAS Sama Permissions
  QualityAuditSamaViewAccess = 'catalog_admin_quality_audit.view_as_sama',
  QualityAuditSamaModifyAccess = 'catalog_admin_quality_audit.modify_as_sama',

  // QAS Sama Manager Permissions
  QualityAuditSamaModifyAssigneeAccess = 'catalog_admin_quality_audit.modify_assignee_as_sama',
  QualityAuditSamaModifyReviewerAccess = 'catalog_admin_quality_audit.modify_reviewer_as_sama',

  // QAS EY Permissions
  QualityAuditEyViewAccess = 'catalog_admin_quality_audit.view_as_ey',
  QualityAuditEyModifyAccess = 'catalog_admin_quality_audit.modify_as_ey',

  // QAS EY Manager Permissions
  QualityAuditEyModifyAssigneeAccess = 'catalog_admin_quality_audit.modify_assignee_as_ey',
  QualityAuditEyModifyReviewerAccess = 'catalog_admin_quality_audit.modify_reviewer_as_ey',

  // QAS KPMG Permissions
  QualityAuditKpmgViewAccess = 'catalog_admin_quality_audit.view_as_kpmg',
  QualityAuditKpmgModifyAccess = 'catalog_admin_quality_audit.modify_as_kpmg',
  QualityAuditKpmgModifyAssigneeAccess = 'catalog_admin_quality_audit.modify_assignee_as_kpmg',
  QualityAuditKpmgModifyReviewerAccess = 'catalog_admin_quality_audit.modify_reviewer_as_kpmg',

  // QAS InTouch Permissions
  QualityAuditInTouchViewAccess = 'catalog_admin_quality_audit.view_as_intouch',
  QualityAuditInTouchModifyAccess = 'catalog_admin_quality_audit.modify_as_intouch',

  // QAS InTouch Manager Permissions
  QualityAuditInTouchModifyAssigneeAccess = 'catalog_admin_quality_audit.modify_assignee_as_intouch',
  QualityAuditInTouchModifyReviewerAccess = 'catalog_admin_quality_audit.modify_reviewer_as_intouch',

  // Catalog Tools Permissions
  ImageUploadsViewAccess = 'catalog_image_uploads.view',

  // New API Permissions
  ImageManagementViewAccess = 'catalog_admin_image_management.view',

  // Legacy API Permissions
  CatalogAdmin = 'catalog-admin',

  // Price Anomaly Investigation Permissions
  // These match the backend permission registry exactly (see retailer-platform-api/app/support/permission.rb)
  PriceAnomalyInvestigationViewAccess = 'catalog_admin_price_anomaly_investigation.view',
  PriceAnomalyInvestigationCreateAccess = 'catalog_admin_price_anomaly_investigation.create',
  PriceAnomalyInvestigationPatchAccess = 'catalog_admin_price_anomaly_investigation.patch',
  PriceAnomalyInvestigationPatchHighVolumeAccess = 'catalog_admin_price_anomaly_investigation.patch_high_volume',

  // Source Priority Permissions
  SourcePriorityViewAccess = 'catalog_admin_source_priority.view',
  SourcePriorityModifyAccess = 'catalog_admin_source_priority.modify',
  SourcePriorityApproveAccess = 'catalog_admin_source_priority.approve',
}
